// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.uploadIdContainer.differentData.resumeComponent.';

const BIRTHDATE = `${DOMAIN}birthDateLabel`,
  FULL_NAME = `${DOMAIN}fullNameLabel`,
  NACIONALITY = `${DOMAIN}nacionalityLabel`;

export { BIRTHDATE, FULL_NAME, NACIONALITY };
